module.exports = __webpack_public_path__ + "img/_b_.835fadf2.svg";